import { FC } from 'react'
import { ScriptValueDialog } from '@microservices/wiskey-react-components'

import { useEditConfig } from '@providers/EditConfigProvider'

import {
  CONFIG_MENU_OPTION,
  CONFIG_MENU_TITLES,
  CONFIG_SCRIPT_VALUE_DIALOG_APPLY_BUTTON_TITLES,
} from '@constants'

export const EditConfigScriptDialog: FC = () => {
  const {
    configMenuOption,
    configFileText,
    isOpenScriptDialog,
    handleApply,
    handleFileUpload,
    handleCancel,
    handleCopyScript,
  } = useEditConfig()

  if (!configMenuOption) return null

  return (
    <ScriptValueDialog
      isDirty={!!configFileText && configMenuOption !== CONFIG_MENU_OPTION.EDIT}
      isShow={isOpenScriptDialog}
      language='jsx'
      noValidate={true}
      title={CONFIG_MENU_TITLES[configMenuOption ?? CONFIG_MENU_OPTION.IMPORT]}
      uploadFileBtnSx={{ width: 'auto', height: 40 }}
      value={configFileText}
      width='80vw'
      btnText={
        CONFIG_SCRIPT_VALUE_DIALOG_APPLY_BUTTON_TITLES[
          configMenuOption ?? CONFIG_MENU_OPTION.IMPORT
        ]
      }
      onClose={handleCancel}
      onCopy={handleCopyScript}
      onFileUpload={configMenuOption === CONFIG_MENU_OPTION.IMPORT ? handleFileUpload : undefined}
      onSave={handleApply}
    />
  )
}
